import { SelectField } from '@flash-tecnologia/hros-web-ui-v2';
import {
  classificacaoEmpresaSelectOptions,
  faturamentoEstimadoSelectOptions,
} from './selectFieldOptions';
import { useEffect, useState } from 'react';
import { CompanyCompliance } from 'bff/src/domain/model/compliance.model';
import { CompanyInformationSchema } from 'bff/src/application/schemas/company.schema';
import { PageSubmitLayout } from 'components/Layout/PageBaseLayout';
import { InputLayout } from 'components/Layout/InputLayout';
import { useBffFetch } from 'api/getData';
import { dispatchToast, dispatchToastErrorHandler } from 'utils/dispatchToast';
import { useNavigate } from 'react-router-dom';
import { useSelectedCompany } from '@flash-tecnologia/hros-web-utility';

export const Company = () => {
  const navigate = useNavigate();
  const { selectedCompany } = useSelectedCompany();

  const [estimatedAnnualRevenue, setEstimatedAnnualRevenue] = useState<{
    value: CompanyCompliance['estimatedAnnualRevenue'] | '';
    label: string;
  }>({
    value: '',
    label: '',
  });
  const [estimatedAnnualRevenueError, setEstimatedAnnualRevenueError] =
    useState<string>();

  const [companyClassification, setCompanyClassification] = useState<{
    value: CompanyCompliance['classification'] | '';
    label: string;
  }>({
    value: '',
    label: '',
  });

  const [companyClassificationError, setCompanyClassificationError] =
    useState<string>();

  const { loading, fetchBff } = useBffFetch<CompanyInformationSchema, unknown>({
    path: `/v1/companies/${selectedCompany.id}/information`,
    method: 'POST',
    onSuccess: () => {
      dispatchToast({
        title: 'Sucesso',
        content: 'Informações enviadas com sucesso!',
        type: 'success',
      });
      navigate('/');
    },
    onError: (err) => dispatchToastErrorHandler(err.statusCode),
  });

  useEffect(() => {
    setEstimatedAnnualRevenue({ value: '', label: '' });
    setEstimatedAnnualRevenueError('');
    setCompanyClassification({ value: '', label: '' });
    setCompanyClassificationError('');
  }, [selectedCompany]);

  const handleSubmit = () => {
    if (!estimatedAnnualRevenue?.value) {
      setEstimatedAnnualRevenueError('Campo é obrigatório!');
    } else {
      setEstimatedAnnualRevenueError('');
    }
    if (!companyClassification?.value) {
      setCompanyClassificationError('Campo é obrigatório!');
    } else {
      setCompanyClassificationError('');
    }
    if (estimatedAnnualRevenue?.value && companyClassification?.value) {
      fetchBff({
        estimatedAnnualRevenue: estimatedAnnualRevenue.value,
        classification: companyClassification.value,
      });
    }
  };

  return (
    <PageSubmitLayout
      pageTitle="Informações complementares da empresa"
      descriptionTitle="Dados complementares"
      descriptionSubTitle="Informe os dados necessários para regularização da empresa na plataforma."
      onSubmit={() => handleSubmit()}
      onCancel={() => navigate('/')}
      loading={loading}
    >
      <InputLayout
        title="Capacidade financeira"
        subTitle="Qual o faturamento estimado da sua empresa no último ano?"
      >
        <SelectField
          label="Faturamento estimado no último ano *"
          value={estimatedAnnualRevenue?.value}
          style={{ marginTop: '25px' }}
          fullWidth
          options={faturamentoEstimadoSelectOptions}
          onSelectChange={(_, option) => setEstimatedAnnualRevenue(option)}
          error={!!estimatedAnnualRevenueError}
          helperText={estimatedAnnualRevenueError}
        />
      </InputLayout>
      <InputLayout
        title="Classificação da empresa"
        subTitle="Qual a classificação da sua empresa em relação à origem do seu
          capital?"
      >
        <SelectField
          label="Classificação da empresa *"
          value={companyClassification}
          style={{ marginTop: '25px' }}
          fullWidth
          options={classificacaoEmpresaSelectOptions}
          onSelectChange={(_, option) => setCompanyClassification(option)}
          error={!!companyClassificationError}
          helperText={companyClassificationError}
        />
      </InputLayout>
    </PageSubmitLayout>
  );
};
